(function () {
  function scrollToRelated(e) {
    var btn = e.currentTarget;
    e.preventDefault();
    var targetId = btn.getAttribute('data-scroll-target');
    var target = document.getElementById(targetId);
    if (!target) {
      window.location.hash = '#'+targetId;
      return;
    }

    var header = document.querySelector('.section-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var rect = target.getBoundingClientRect();
    var offsetTop = window.pageYOffset + rect.top - headerHeight - 16; // 16px gap

    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.js-scroll-to-section');
    if (!buttons || !buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', scrollToRelated);
    });
  });
})();
